import type { EdgeContextMenu } from 'components/Graph/GraphState';
import { closeNodeContextMenu } from 'components/Graph/commands/nodes/closeNodeContextMenu';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export type OpenEdgeContextMenuCommand = EdgeContextMenu;

export const openEdgeContextMenu: GraphCommandFactory<
  OpenEdgeContextMenuCommand
> = (cmdContext, dispatch) => (command) => {
  cmdContext.updateState((draft) => {
    draft.edgeContextMenu = command;
  });

  dispatch(closeNodeContextMenu);
};
